module.exports = __webpack_public_path__ + "img/DK31843219.a11accaf.png";